module.exports = __webpack_public_path__ + "static/img/celoscope-9.082952f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-9.jpg
// module id = BpRi
// module chunks = 51